import {
  IData_Event_Type_Summary,
  IData_Event_Type_Summary_Tree,
} from '../types/utils'

// get the list of event types as a tree
// with namespaces split
// this will only work with one level e.g. crm:create_contact
// TODO: make this work with multiple level events
export const getEventTypeTree = (
  eventTypes: IData_Event_Type_Summary[],
): IData_Event_Type_Summary_Tree[] => {
  if(!eventTypes) return []

  const topItems: IData_Event_Type_Summary_Tree[] = []

  eventTypes.forEach(type => {
    const [ namespace, name ] = type.type.split(':')
    let topItem: IData_Event_Type_Summary_Tree | undefined = topItems.find(i => i.type == namespace)
    if(!topItem) {
      topItem = {
        type: namespace,
        count: 0,
        children: [],
      }
      topItems.push(topItem)
    }

    if(name) {
      topItem.children.push({
        type: type.type,
        count: type.count,
        children: [],
      })
    }

    topItem.count += type.count
  })
  return topItems
}

// get a flat list of select options from the type tree
// insert spacing before nested itemss
// this will only work with one level e.g. crm:create_contact
// TODO: make this work with multiple level events
export const getEventTypeTreeSelectOptions = (
  eventTypes: IData_Event_Type_Summary[],
): {name:string,value:string}[] => {
  const tree = getEventTypeTree(eventTypes)
  return tree.reduce<{name: string, value: string}[]>((all, item) => {
    const options = [{
      name: `${item.type} (${item.count})`,
      value: item.type,
    }].concat(item.children.map(child => {
      return {
        name: `---> ${child.type} (${child.count})`,
        value: child.type,
      }
    }))
    return all.concat(options)
  }, [])
}